:host {
  display: grid;
  block-size: 100%;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--color-text-neutral-default);
  gap: var(--spacing-gap-xl);
  text-align: center;
  padding: var(--spacing-padding-xxl);
}

.check-icon {
  $checkIconSize: 64px;
  block-size: $checkIconSize;
  inline-size: $checkIconSize;
  border-radius: 50%;
  background-color: var(--color-accent-success-contrast);
  background-image: var(--icon__system_check_on-surface--enabled);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 32px;
  margin-block-end: 16px;
}

.genexus-next-logo {
  inline-size: 140px;
  block-size: 30px;
  margin-block-start: 108px;
  mask-size: contain;
  background-color: var(--color-icon-neutral-default);
}
